import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

import useGridInputs from '../hooks/useGridInputs';
import useUnifiedProductGridData from '../hooks/useUnifiedProductGridData';

import DiscoveryGuideFilterPills from './DiscoveryGuide/DiscoveryGuideFilterPills';
import MobileGridCustomColorInitializer from './MobileGridFilters/MobileGridCustomColorInitializer';
import MobileGridFilters from './MobileGridFilters/MobileGridFilters';
import MobileGridSortDropdown from './MobileGridSortDropdown';

const HeaderWrapper = styled.div``;

const HeaderLabelsWrapper = styled.div`
  ${({ theme }) => theme.mobileGridHeaderStyle};
`;

const HeaderTitle = styled.h1`
  font-weight: 700;
  font-size: 24px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
  justify-content: center;
  display: flex;
`;

const SubheaderTitle = styled.h2`
  font-weight: 400;
  font-size: 1rem;
  padding-left: 16px;
  padding-top: 8px;
  justify-content: center;
  display: flex;
`;

const ControlsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
`;

const MobileGridFiltersWrapper = styled.div`
  margin-left: auto;
`;

const MobileGridHeader = ({ isFilterDrawerOpen, setIsFilterDrawerOpen }) => {
  // search grid, ie from ConstructorSearchV1_1, do not set gridHeader/subheader,
  // and we do not want to add setting them there in case coupling useCioSearchAndGqlProducts
  // there leads to circular dependencies later down the line (at time of writing it does not)
  //
  // so instead, we set search headers here, if there are search results we use them instead of
  // the builderGridHeader in useGridInputs (ie for categories/collections from Builder pages)
  const {
    gridHeader: builderGridHeader,
    hideFilters,
    hideSort,
  } = useGridInputs();
  const { searchQuery, totalNumResults: count } = useUnifiedProductGridData();

  const searchGridHeader = (
    <FormattedMessage
      id="search_results.results_heading_search"
      defaultMessage='Results for "{searchQuery}"'
      values={{ searchQuery }}
    />
  );
  const searchGridSubheader = (
    <FormattedMessage
      id="search_results.results_heading_total_count"
      defaultMessage="{count} results"
      values={{ count }}
    />
  );

  const gridHeader = searchQuery ? searchGridHeader : builderGridHeader;
  const gridSubheader = count ? searchGridSubheader : null;

  return (
    <HeaderWrapper>
      <MobileGridCustomColorInitializer />
      <HeaderLabelsWrapper>
        <HeaderTitle>{gridHeader}</HeaderTitle>
        {gridSubheader && <SubheaderTitle>{gridSubheader}</SubheaderTitle>}
      </HeaderLabelsWrapper>
      <DiscoveryGuideFilterPills />
      <ControlsWrapper>
        {!hideSort && <MobileGridSortDropdown />}
        {!hideFilters && (
          <MobileGridFiltersWrapper>
            <MobileGridFilters
              isFilterDrawerOpen={isFilterDrawerOpen}
              setIsFilterDrawerOpen={setIsFilterDrawerOpen}
            />
          </MobileGridFiltersWrapper>
        )}
      </ControlsWrapper>
    </HeaderWrapper>
  );
};

MobileGridHeader.propTypes = {
  isFilterDrawerOpen: PropTypes.bool.isRequired,
  setIsFilterDrawerOpen: PropTypes.func.isRequired,
};

export default MobileGridHeader;
